import { render, staticRenderFns } from "./Hotspot-item.vue?vue&type=template&id=c8e15b44"
import script from "./Hotspot-item.vue?vue&type=script&lang=js"
export * from "./Hotspot-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports